<template>
    <footer id="footer_v2" class="s-footer">
        <section class="page-section">
            <div class="grid-container">
                <div class="grid-x grid-padding-x align-center">
                    <div class="cell">
                        <section id="f-gdbadge" class="section-content">
                            <ul>
                                <li>
                                    <a href="http://www.g-mark.org/activity/2015/results.html">
                                        <img src="https://motion-gallery.net/images/gdbadge_0.png" alt="">
                                    </a>
                                </li>
                                <li>
                                    <a href="http://www.g-mark.org/activity/2015/best100.html">
                                        <img src="https://motion-gallery.net/images/gdbadge_1.png" alt="">
                                    </a>
                                </li>
                            </ul>
                        </section>
                    </div>
                </div>
                <div class="grid-x grid-padding-x align-center">
                    <div class="medium-5 large-5 cell">
                        <section class="section-content">
                            <nav>
                                <h2>プロジェクトを探す</h2>

                                <ul class="list-category">
                                    <li class="m-list-category">
                                        <a href="https://motion-gallery.net/categories/Film">映画</a>
                                    </li>

                                    <li class="m-list-category">
                                        <a href="https://motion-gallery.net/categories/Art">アート</a>
                                    </li>

                                    <li class="m-list-category">
                                        <a href="https://motion-gallery.net/categories/Photography">写真</a>
                                    </li>

                                    <li class="m-list-category">
                                        <a href="https://motion-gallery.net/categories/Music">音楽</a>
                                    </li>

                                    <li class="m-list-category">
                                        <a href="https://motion-gallery.net/categories/Animation">アニメ</a>
                                    </li>

                                    <li class="m-list-category">
                                        <a href="https://motion-gallery.net/categories/Game">ゲーム</a>
                                    </li>

                                    <li class="m-list-category">
                                        <a href="https://motion-gallery.net/categories/Community">コミュニティ</a>
                                    </li>

                                    <li class="m-list-category">
                                        <a href="https://motion-gallery.net/categories/Product">プロダクト</a>
                                    </li>

                                    <li class="m-list-category">
                                        <a href="https://motion-gallery.net/categories/Dance">演劇・ダンス</a>
                                    </li>

                                    <li class="m-list-category">
                                        <a href="https://motion-gallery.net/categories/Books">本</a>
                                    </li>

                                    <li class="m-list-category">
                                        <a href="https://motion-gallery.net/categories/Technology">テクノロジー</a>
                                    </li>

                                    <li class="m-list-category">
                                        <a href="https://motion-gallery.net/categories/Performance">パフォーマンス</a>
                                    </li>

                                    <li class="m-list-category">
                                        <a href="https://motion-gallery.net/categories/Sports">スポーツ</a>
                                    </li>

                                    <li class="m-list-category">
                                        <a href="https://motion-gallery.net/categories/Food">フード</a>
                                    </li>

                                    <li class="m-list-category">
                                        <a href="https://motion-gallery.net/categories/Intelligence">ジャーナリズム</a>
                                    </li>
                                </ul>
                            </nav>
                        </section>
                    </div>
                    <div class="medium-6 large-6 cell">
                        <section class="section-content">
                            <nav>
                                <h2>MotionGalleryについて</h2>
                                <ul class="list-menu">
                                    <li>
                                        <a href="https://motion-gallery.net/about">MotionGalleryとは？</a>
                                    </li>
                                    <li>
                                        <a href="https://motion-gallery.net/college">MotionGallery College</a>
                                    </li>
                                    <li>
                                        <a href="https://motion-gallery.net/faq">よくある質問</a>
                                    </li>
                                    <li>
                                        <a href="https://motion-gallery.net/faq">ヘルプ</a>
                                    </li>
                                    <li>
                                        <a href="https://info.motion-gallery.net/contacts/">お問い合わせ</a>
                                    </li>
                                    <li>
                                        <a href="https://motion-gallery.net/media_relations">取材のご相談</a>
                                    </li>
                                    <li>
                                        <a href="https://info.motion-gallery.net/support/goto-2020/">＃２０２０年代</a>
                                    </li>
                                    <li>
                                        <a href="https://motion-gallery.net/privacy">プライバシーポリシー</a>
                                    </li>
                                    <li>
                                        <a href="https://motion-gallery.net/term">利用規約</a>
                                    </li>
                                    <li>
                                        <a href="https://motion-gallery.net/support/tokyo">東京都クラウドファンディング支援事業</a>
                                    </li>
                                    <li>
                                        <a href="https://info.motion-gallery.net/support/local/">ローカル</a>
                                    </li>
                                    <li>
                                        <a href="https://motion-gallery.net/tokusho">特商法表示</a>
                                    </li>
                                </ul>
                            </nav>
                        </section>
                    </div>
                </div>
                <div class="grid-x grid-padding-x align-center">
                    <div class="medium-8 large-8 cell">
                        <section class="section-content">
                            <p id="f-logo">
                                <img src="https://motion-gallery.net/images/logo_compact_reversal.png" alt="Motion Gallery">
                            </p>
                            <nav>
                                <ul class="list-social">
                                    <li>
                                        <a href="https://www.facebook.com/motiongallery" target="_blank">

                                            <span class="sprite -facebook ">
                                                <svg viewBox="0 0 1 1">
                                                    <use xlink:href="/contacts/img/sprites.svg#facebook" />
                                                </svg>
                                            </span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.instagram.com/motiongallery2011/" target="_blank">

                                            <span class="sprite -instagram ">
                                                <svg viewBox="0 0 1 1">
                                                    <use xlink:href="/contacts/img/sprites.svg#instagram" />
                                                </svg>
                                            </span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://twitter.com/motiongallery" target="_blank">

                                            <span class="sprite -twitter ">
                                                <svg viewBox="0 0 1 1">
                                                    <use xlink:href="/contacts/img/sprites.svg#twitter" />
                                                </svg>
                                            </span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.youtube.com/user/MotionGallerys" target="_blank">

                                            <span class="sprite -youtube ">
                                                <svg viewBox="0 0 1 1">
                                                    <use xlink:href="/contacts/img/sprites.svg#youtube" />
                                                </svg>
                                            </span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://motion-gallery.net/blog" target="_blank">

                                            <span class="sprite -blog ">
                                                <svg viewBox="0 0 1 1">
                                                    <use xlink:href="/contacts/img/sprites.svg#blog" />
                                                </svg>
                                            </span>
                                        </a>
                                    </li>
                                </ul>
                            </nav>
                        </section>
                    </div>
                    <div class="medium-4 large-4 cell">
                        <section class="section-content">
                            <p id="f-copyright">© 2011 MotionGallery Inc.</p>
                        </section>
                    </div>
                </div>
            </div>
        </section>
    </footer>
</template>

<script>
export default {
    name: 'FooterTag',
    data: () => ({
    })
}
</script>
